module.exports = __webpack_public_path__ + "p3_img1.jpg?6de1403b00f33e8f6e2b4ae66e21c2a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img1.jpg
// module id = 110
// module chunks = 0